import { Component, OnInit, AfterViewInit, Input, Injector, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import * as L from 'leaflet';

import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { MapService } from 'src/app/utils/map.service';
import { MapConstants } from 'src/app/utils/map.constant';
import { CommonHttpService } from 'src/app/utils/common-http.service';
import { RainfallService } from '../../side-bar/extreme-weather/rainfall/rainfall.service';
import { resolve } from 'url';
import { ExtremeWeatherDataService } from '../../side-bar/extreme-weather/extreme-weather-data.service';

@Component({
  selector: 'app-gis-mini-map',
  templateUrl: './gis-mini-map.component.html',
  styleUrls: ['./gis-mini-map.component.scss']
})
export class GisMiniMapComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input() mapId: string;
  @Input() layerList: any;
  @Input() otherOptions: any;
  @Input() enableMapInteraction: boolean;

  map: any;
  view: string;
  STATENAME: any;
  serviceMap: any;
  adminSelected: boolean;
  activeLayers: any[] = [];
  heatMapLayer: any;
  clickedLocationMarker: any;
  adminBasinSubscription: any;
  clickedLocationTooltip: any;
  probabilityHeatMapData: object;
  currentPlayPosition = null;
  currentPlayPositionSubscription: any;
  currentHeatMapData: any;
  forecastLengthSubscription: any;
  weeklyModelDate: any;
  legend: any;

  constructor(private route: ActivatedRoute, private utils: UtilsService,
              private mapService: MapService, private injector: Injector,
              private httpService: CommonHttpService, private router: Router,
              private rainfallService: RainfallService,
              private extremeWeatherDataService : ExtremeWeatherDataService) {
    const stateUrlId = this.route.snapshot.paramMap.get('id');
    this.STATENAME = ProjConstants.IDTOSTATENAMEMAPPING[stateUrlId];
    this.utils.getAdminBasinToggle().subscribe(
      value => {
        this.adminSelected = value;
        if (this.adminSelected === true) {
          this.view = 'Admin';
        } else {
          this.view = 'Basin';
        }
      }
    ).unsubscribe();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
        this.initMap();
    }, 0);
    this.addSubscriptions();
}

  ngOnDestroy() {
    if (!isNullOrUndefined(this.adminBasinSubscription)) {
      this.adminBasinSubscription.unsubscribe();
    }
    if (!isNullOrUndefined(this.currentPlayPositionSubscription)) {
      this.currentPlayPositionSubscription.unsubscribe();
    }
    if (!isNullOrUndefined(this.forecastLengthSubscription)) {
      this.forecastLengthSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!document.getElementById(this.mapId || 'miniMap')) {
        // console.warn("Skipping map initialization as container is not available yet.");
        return;
    }
    this.initMap();
    if (changes.enableMapInteraction && changes.enableMapInteraction.currentValue) {
      this.enableInteractionControl();
    }
}
  initMap() {
    const mapId = !isNullOrUndefined(this.mapId) ? this.mapId : 'miniMap';
    const mapElement = document.getElementById(mapId);
    if (!mapElement) {
        // console.error(`Element with ID ${mapId} not found!`);
        return;
    }
    this.map = L.map(mapId, this.mapService.getGisMiniMapOptions(this.STATENAME, ProjConstants));
    this.injectService();
    this.createPanes();
    this.addMapEvents();
    this.addLegend();
    if (!this.enableMapInteraction) {
      this.disableInteractionControl();
    }
  }

  injectService() {
    this.serviceMap = this.injector.get<any>(this.otherOptions['service']);
  }

  createPanes() {
    MapConstants.PANE_LIST.forEach(pane => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }

  addMapEvents() {
    this.map.on({
      zoomstart: (e: L.LayerEvent) => {
        {
          if (!isNullOrUndefined(this.clickedLocationMarker)) {
            this.clickedLocationMarker.unbindTooltip();
            this.clickedLocationMarker.bindTooltip(this.clickedLocationTooltip);
            this.clickedLocationMarker = null;
          }
        }
      }
    });
  }

  addBaseLayers(layerList) {
    for (const index in layerList) {
      if (index) {
        const layer = layerList[index];
        if (layer['type'] === 'Base' && (layer['view'] === this.view || layer['view'] === 'Both')) {
          const layerObj = this.serviceMap.createLayer(layer, this);
          if (!isNullOrUndefined(layerObj['layer'])) {
            if (!isNullOrUndefined(layerObj['layer'].getAttribution())) {
              layerObj['layer'].options.attribution = '<a href = \'https://www.ecmwf.int/\'> Data Source : ECMWF </a>';
            }
            layer.hasOwnProperty('hidelayer') ? (layer['hidelayer'] == false || !layer['hidelayer']) : layerObj['layer'].addTo(this.map);
            this.activeLayers = this.activeLayers.concat(layerObj);
          }
          layerList[index] = layerObj;
        }
      }
    }
    this.layerList = layerList;
  }

  addSubscriptions() {
    this.adminBasinSubscription = this.utils.getAdminBasinToggle().subscribe(value => {
      if (this.adminSelected !== value) {
        this.adminSelected = value;
        if (this.adminSelected === true) {
          this.view = 'Admin';
        } else {
          this.view = 'Basin';
        }
        this.removeAllLayers();
        setTimeout(() => {
          this.addBaseLayers(this.layerList);
          this.addHeatMapLayer();
        }, 100);
      }
    });
    this.forecastLengthSubscription = this.utils.getForecastLengthChanged().subscribe(value => {
      if (JSON.stringify(value) === '24') {
        if (!isNullOrUndefined(this.currentPlayPositionSubscription)) {
          this.currentPlayPositionSubscription.unsubscribe();
        }
      }
      this.removeAllLayers();
      setTimeout(() => {
        this.addBaseLayers(this.layerList);
        if(this.route.snapshot.paramMap.get('time') === 'weekly'){
          this.getWeeklyProbabilityHeatMapData()
        }
        else{
          this.getProbabilityHeatMapData();
        }
      }, 100);
    });
  }

  removeAllLayers() {
  if (!this.map) {
    // console.warn('Map is not initialized yet.');
    return;
  }
  this.map.eachLayer(layer => {
    this.map.removeLayer(layer);
  });
}

  getProbabilityHeatMapData() {
    this.probabilityHeatMapData = {};
    if (this.route.snapshot.paramMap.get('time') === '10' && this.router.url.split('/')[2] === 'rainfall') {
      this.currentPlayPositionSubscription = this.utils.getCurrentPlayPosition().subscribe(value => {
        if (value !== this.currentPlayPosition) {
          this.currentPlayPosition = value;
          if (this.route.snapshot.paramMap.get('time') === '10' && this.router.url.split('/')[2] === 'rainfall') {
            this.changeHeatMapLayerForPlayPosition();
          }
        }
      });
      let counter = 0;
      for (let i = 0; i < 7; i++) {
        const postData = {};
        postData['type'] = this.mapId.split('ensmblMap')[1];
        const date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 5, 30, 0, 0);
        date.setDate(date.getDate() + i);
        postData['timeStamp'] = date.getTime().toString();
        postData['blockLength'] = 'day';
        // postData['color_pallete'] = 'ts_color';
        this.httpService.makePostApiCall('RAINFALLENSEMBLEHEATMAPDATA', postData).subscribe((res: any) => {
          if (res) {
            this.probabilityHeatMapData[postData['timeStamp']] = res;
            if (isNullOrUndefined(this.currentPlayPosition) && i === 0) {
              this.currentHeatMapData = this.probabilityHeatMapData[postData['timeStamp']];
              this.addHeatMapLayer();
            } else if (postData['timeStamp'] === this.currentPlayPosition) {
              this.currentHeatMapData = this.probabilityHeatMapData[postData['timeStamp']];
              this.addHeatMapLayer();
              counter = 1;
            }
          }
        });
        if (i === 6 && counter === 0) {
          date.setDate(date.getDate() - 6);
          this.currentHeatMapData = this.probabilityHeatMapData[date.getTime().toString()];
          this.addHeatMapLayer();
        }
      }
    } else if (this.route.snapshot.paramMap.get('time') === '24' && this.router.url.split('/')[2] === 'rainfall') {
      const postData = {};
      postData['type'] = this.mapId.split('ensmblMap')[1];
      const date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 5, 30, 0, 0);
      postData['timeStamp'] = date.getTime().toString();
      this.httpService.makePostApiCall('RAINFALLENSEMBLEHEATMAPDATA', postData).subscribe((res: any) => {
        if (res) {
          this.probabilityHeatMapData[postData['timeStamp']] = res;
          this.currentHeatMapData = this.probabilityHeatMapData[postData['timeStamp']];
          this.addHeatMapLayer();
        }
      });
    } else if (this.router.url.split('/')[1] === 'weatherdata'){
      const postData = {};
      postData['type'] = this.mapId.split('ensmblMap')[1];
      postData['color_pallete'] = "det_color";
      postData['timeStamp'] = this.otherOptions['timestamp'];
      this.httpService.makePostApiCall('RAINFALLENSEMBLEHEATMAPDATA', postData).subscribe((res: any) => {
        if (res) {
          this.probabilityHeatMapData[postData['timeStamp']] = res;
          this.currentHeatMapData = this.probabilityHeatMapData[postData['timeStamp']];
          this.addHeatMapLayer();
        }
      });
    }
  }

  getWeeklyModelDate(){
    return new Promise((resolve,reject) => {
      if(this.weeklyModelDate != undefined) resolve(this.weeklyModelDate);
      else {
        this.extremeWeatherDataService.getForecastFileTimeStamp('ECMWF_EXT',null).then(
        data => {
          this.weeklyModelDate = data;
          resolve(this.weeklyModelDate);
        });
      }
    })
  }

  getWeeklyProbabilityHeatMapData() {
    this.probabilityHeatMapData = {};
    this.currentPlayPositionSubscription = this.utils.getCurrentPlayPosition().subscribe(value => {
      if (value !== this.currentPlayPosition) {
        this.currentPlayPosition = value;
        // console.log(this.currentPlayPosition);
        if (this.route.snapshot.paramMap.get('time') === 'weekly' && this.router.url.split('/')[2] === 'rainfall') {
          this.changeHeatMapLayerForPlayPosition();
        }
      }
    });
    let counter = 0;
    this.getWeeklyModelDate().then(weeklyModelDate  => {
      if(weeklyModelDate == null) return;
      let modelArray = this.rainfallService.getWeeklyTimeStamps(weeklyModelDate);
      for (const i in modelArray) {
        // console.log(modelArray[i]);
        const postData = {};
        postData['type'] = this.mapId.split('ensmblMap')[1];
        postData['source'] = 'ECMWF_EXT';
        postData['timeStamp'] = modelArray[i]['timeStamp'].toString();
        postData['blockLength'] = 'week';
        // postData['color_pallete'] = 'ts_color';
        this.httpService.makePostApiCall('RAINFALLENSEMBLEHEATMAPDATA', postData).subscribe((res: any) => {
          if (res) {
            this.probabilityHeatMapData[postData['timeStamp']] = res;
            if (isNullOrUndefined(this.currentPlayPosition) && i === '0') {
              this.currentHeatMapData = this.probabilityHeatMapData[postData['timeStamp']];
              this.addHeatMapLayer();
            } else if (postData['timeStamp'] === this.currentPlayPosition) {
              this.currentHeatMapData = this.probabilityHeatMapData[postData['timeStamp']];
              this.addHeatMapLayer();
              counter = 1;
            }
          }
        });
        // if (i === '0' && counter === 0) {
        //   date.setDate(date.getDate() - 6);
        //   this.currentHeatMapData = this.probabilityHeatMapData[date.getTime().toString()];
        //   this.addHeatMapLayer();
        // }
      }
    } );

  }

  addHeatMapLayer() {
    if (!isNullOrUndefined(this.heatMapLayer) && this.map.hasLayer(this.heatMapLayer)) {
      this.map.removeLayer(this.heatMapLayer);
    }
    setTimeout(() => {
      if (!isNullOrUndefined(this.currentHeatMapData)) {
        // this.heatMapLayer = L.imageOverlay(this.currentHeatMapData['heatMapImage'], [[this.currentHeatMapData['heatMapImageBound']['southWest']['latitude'], this.currentHeatMapData['heatMapImageBound']['southWest']['longitude']],
        //   [this.currentHeatMapData['heatMapImageBound']['northEast']['latitude'], this.currentHeatMapData['heatMapImageBound']['northEast']['longitude']]], { pane: 'heatMap' });
        this.heatMapLayer = L.imageOverlay(this.currentHeatMapData['heatMapImage'], [[4.96, 64.96],
          [40.04, 100]], { pane: 'heatMap' });
        this.heatMapLayer.addTo(this.map);
      }
    }, 50);
  }

  changeHeatMapLayerForPlayPosition() {
    if (!isNullOrUndefined(this.currentPlayPosition) && !isNullOrUndefined(this.probabilityHeatMapData[this.currentPlayPosition])) {
      this.currentHeatMapData = this.probabilityHeatMapData[this.currentPlayPosition];
      this.addHeatMapLayer();
    }
  }

  disableInteractionControl() {
    this.map.touchZoom.disable();
    this.map.doubleClickZoom.disable();
    this.map.scrollWheelZoom.disable();
    this.map.boxZoom.disable();
    this.map.keyboard.disable();
  }

  enableInteractionControl() {
    this.map.touchZoom.enable();
    this.map.doubleClickZoom.enable();
    this.map.scrollWheelZoom.enable();
    this.map.boxZoom.enable();
    this.map.keyboard.enable();
  }

  addLegend() {
    let data: any;
    //function for legend styling
    if (this.mapId == 'ensmblMap2.5') {
      data = this.otherOptions.lightRainfall;
    } else if (this.mapId == 'ensmblMap15.6') {
      data = this.otherOptions.moderateRainfall;
    } else if (this.mapId == 'ensmblMap64.5') {
      data = this.otherOptions.heavyRainfall;
    } else if (this.mapId == 'ensmblMap115.6') {
      data = this.otherOptions.vheavyRainfall;
    }
    if (this.legend) {
      this.legend.remove();
    }

    const legend = (L as any).control({ position: 'bottomright' });
    legend.onAdd = () => {
      const div = L.DomUtil.create('div', 'info');
      if (data != null && data != undefined) {
        if (data.Units != undefined && data.Units != null) {
          div.innerHTML += '<p class="bg-white font-weight-bold  text-center my-0">'
            + data.Units + '</p';
        }
        const ranges = data.colorValues;
        for (let i = ranges.length - 1; i >= 0; i--) {
          div.innerHTML +=
            '<p class="my-0 font-weight-bold text-center" style="background-color:' + ranges[i]['backgroundColor'] + ' ; color:' + ranges[i]['color'] + '">' + ranges[i].text + '</p>';
        }
      }
      return div;
    };
    this.legend = legend;

    legend.addTo(this.map);
  }

}
